import { render, staticRenderFns } from "./newSchemeDetailsTableReport.vue?vue&type=template&id=aa41de96"
import script from "./newSchemeDetailsTableReport.vue?vue&type=script&lang=js"
export * from "./newSchemeDetailsTableReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports